import DOMPurify from 'dompurify'
import ReactMarkdown from 'react-markdown'

import { cn } from 'src/shared/components/ui/utils'

/** Styles anchor tags from Tiptap HTML and markdown — prose alone often inherits body text color. */
const MESSAGE_BODY_LINK_CLASSNAME =
  '[&_a]:text-blue-600 [&_a]:underline [&_a]:underline-offset-2 [&_a]:hover:text-blue-700'

/**
 * Renders message content. Supports both HTML (from Tiptap) and plain text/markdown (legacy).
 * HTML content is sanitized with DOMPurify. Plain text uses ReactMarkdown for formatting.
 */
export const SafeMessageContent = ({
  content,
  className,
}: {
  content: string
  className?: string
}) => {
  const isHtml = /<[a-z][\s\S]*>/i.test(content)

  if (isHtml) {
    const sanitized = DOMPurify.sanitize(content, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'a', 'ul', 'ol', 'li', 'code'],
      ALLOWED_ATTR: ['href', 'target', 'rel'],
    })
    return (
      <div
        className={cn(MESSAGE_BODY_LINK_CLASSNAME, className)}
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    )
  }

  return (
    <div className={cn(MESSAGE_BODY_LINK_CLASSNAME, className)}>
      <ReactMarkdown
        components={{
          p: ({ children }) => <p>{children}</p>,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
